var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-button',{staticClass:"badge badge-pill my-1 mr-2 text-capitalize",class:{ active: _vm.isActive },attrs:{"variant":"primary"},on:{"click":_vm.handleClick}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }